<template>
   <div :class="klass">
      <template v-if="featured">
         <div class="card m-b-30">
            <div class="featured-promotion-item">
               <router-link to="" @click.native="goToPromoDetail" ><img class="card-img-top" :src="imageUrl" alt="Card image cap"></router-link>
                  <div class="card-body">
                        <span class="badge badge-secondary mb-3">Válido al {{validTo}}</span>
                        <router-link to="" @click.native="goToPromoDetail" ><h5 class="card-title font-18">{{title}}</h5></router-link>
                        <p class="card-text mb-0">{{content}}</p>
                  </div> 
            </div>
         </div>
      </template>

      <template v-else>
         <div class="card m-b-30">
            <div class="featured-promotion-item">
               <div class="card-header">
                  <router-link to="" @click.native="goToPromoDetail" ><h5 class="card-title mb-0"> {{title}} </h5></router-link>
               </div>
               <div class="card-body">
                  <div class="row align-items-center">
                        <div class="col-12 col-md-4">
                           <router-link to="" @click.native="goToPromoDetail" ><img :src="imageUrl" class="img-fluid" alt="parent"></router-link>
                        </div>
                        <div class="col-12 col-md-8">
                           <p class="mb-4">{{content}}</p>
                           <!--h5 class="card-title mb-1">Ms. Jessica Matthew</h5-->
                           <p class="mb-0 font-14 font-italic">Válido al {{validTo}}.</p>
                        </div>
                     </div>
               </div> 
            </div>
         </div>
      </template>
   </div>
</template>

<script>
export default {
   name: "Promotion",
   props: {
      id: {
         type: [String, Number],
         required: true,
      },
      title: {
         type: String,
         required: true,
      },
      content: {
         type: String,
         required: true,
      },
      featured: {
         type: Boolean,
      },
      imageUrl: {
         type: String,
         required: true,
      },
      validTo: {
         type: String,
         required: true,
      },
      clickable: {
         type: Boolean,
         default: true
      }
   },
   data(){
      return {
         klass: this.featured ? "col-lg-6 col-md-12 col-sm-12" : "col-lg-6 col-md-6 col-sm-6",
      }
   },
   methods: {
      async goToPromoDetail(id){
         if(this.clickable){
            await this.$router.push({name: "cliente-comprar-promociones"})
         }
      }
   }
}
</script>